import { all, put, take, takeLatest } from 'redux-saga/effects';
import { AUTH_LOGIN, API_AUTH_LOGIN_SUCCESS, apiAuthLogin, } from '@/actions/AuthActionsTs';
import { AUTH_LOGOUT } from '../../actions/AuthActions';
import { LOGOUT_URL } from '../../define/env';
const authSaga = () => {
    /**
     * ログイン処理の実行
     * @param payload
     * @param meta
     * @returns {*}
     */
    function* handleLogin({ meta, payload }) {
        // API実行
        yield put(apiAuthLogin(payload, meta));
        // API完了の待機
        yield take(API_AUTH_LOGIN_SUCCESS);
    }
    /**
     * ログアウト処理の実行
     */
    // eslint-disable-next-line
    function* handleLogout() {
        // サーバー側で全てを消すので遷移のみでOK
        window.location.href = LOGOUT_URL;
    }
    return function* watchAuth() {
        // auth 関連を処理するsaga
        yield all([
            takeLatest((action) => action.type === AUTH_LOGIN, handleLogin),
            takeLatest((action) => action.type === AUTH_LOGOUT, handleLogout),
        ]);
    };
};
export default authSaga;
